import Vue from "vue";
import VueRouter from "vue-router";
import i18n from '@/helpers/i18n';

// Views - Dynamic imports for code splitting
// Each view is loaded only when the route is accessed
const HomePage = () => import(/* webpackChunkName: "home" */ "../views/HomePage.vue");
const WinesPage = () => import(/* webpackChunkName: "wines" */ "../views/WinesPage.vue");
const WineDetail = () => import(/* webpackChunkName: "wine-detail" */ "../views/WineDetail.vue");
const ExperiencesPage = () => import(/* webpackChunkName: "experiences" */ "../views/ExperiencesPage.vue");
const ExperienceDetail = () => import(/* webpackChunkName: "experience-detail" */ "../views/ExperienceDetail.vue");
const Contact = () => import(/* webpackChunkName: "contact" */ "../views/Contact.vue");
const StaticInfos = () => import(/* webpackChunkName: "static" */ "../views/StaticInfos.vue");
const TeamDetail = () => import(/* webpackChunkName: "team" */ "../views/TeamDetail.vue");
const Gallery = () => import(/* webpackChunkName: "gallery" */ "../views/Gallery.vue");
const SatisfactionSurvey = () => import(/* webpackChunkName: "survey" */ "../views/SatisfactionSurvey.vue");
const Payment = () => import(/* webpackChunkName: "payment" */ "../views/Payment.vue");
const PaymentSuccess = () => import(/* webpackChunkName: "payment" */ "../views/PaymentSuccess.vue");

// Header and footer - Keep static as they're used on every page
import AppHeader from "../layout/AppHeader.vue";
import AppFooter from "../layout/AppFooter.vue";

// Page 404 - Keep static for fast error display
import Page404 from "../views/Page404.vue";

Vue.use(VueRouter);

import { CONSTANTS } from '@/helpers/consts';

const routes = [
  {
    path: "/",
    name: "HomePage",
    components: {
      header: AppHeader,
      default: HomePage,
      footer: AppFooter,
    }
  },
  {
    path: i18n.t('vueRoutes.wines'),
    alias: CONSTANTS.supportedLanguages.map(locale => i18n.t('vueRoutes.wines', locale.key) ),
    name: 'Wines',
    components: {
      header: AppHeader,
      default: WinesPage,
      footer: AppFooter
    }
  },
  {
    path: i18n.t('vueRoutes.experiences'),
    alias: CONSTANTS.supportedLanguages.map(locale => i18n.t('vueRoutes.experiences', locale.key) ),
    name: 'Experiences',
    components: {
      header: AppHeader,
      default: ExperiencesPage,
      footer: AppFooter
    }
  },
  {
    path: `${i18n.t('vueRoutes.wines')}/:wineSlug`,
    alias: CONSTANTS.supportedLanguages.map(locale => `${i18n.t('vueRoutes.wines', locale.key)}/:wineSlug` ),
    name: 'WineDetail',
    components: {
      header: AppHeader,
      default: WineDetail,
      footer: AppFooter
    }
  },
  {
    path: `${i18n.t('vueRoutes.experiences')}/:experienceSlug`,
    alias: CONSTANTS.supportedLanguages.map(locale => `${i18n.t('vueRoutes.experiences', locale.key)}/:experienceSlug` ),
    name: 'ExperienceDetail',
    components: {
      header: AppHeader,
      default: ExperienceDetail,
      footer: AppFooter
    }
  },
  {
    path: i18n.t('vueRoutes.contact'),
    alias: CONSTANTS.supportedLanguages.map(locale => i18n.t('vueRoutes.contact', locale.key) ),
    name: 'Contact',
    components: {
      header: AppHeader,
      default: Contact,
      footer: AppFooter
    }
  },
  {
    path: i18n.t('vueRoutes.gallery'),
    alias: CONSTANTS.supportedLanguages.map(locale => i18n.t('vueRoutes.gallery', locale.key) ),
    name: 'Gallery',
    components: {
      header: AppHeader,
      default: Gallery,
      footer: AppFooter
    }
  },
  {
    path: '/satisfactionquestions/:reservationId?',
    alias: '/inquiry/:reservationId?',
    name: 'SatisfactionSurvey',
    components: {
      header: AppHeader,
      default: SatisfactionSurvey,
      footer: AppFooter
    }
  },
  {
    path: '/payment/success',
    name: 'PaymentSuccess',
    components: {
      header: AppHeader,
      default: PaymentSuccess,
      footer: AppFooter
    }
  },
  {
    path: '/payment/:experienceId?',
    name: 'Payment',
    components: {
      header: AppHeader,
      default: Payment,
      footer: AppFooter
    }
  },
  {
    path: `${i18n.t('vueRoutes.teamDetail')}/:memberSlug`,
    alias: CONSTANTS.supportedLanguages.map(locale => `${i18n.t('vueRoutes.teamDetail', locale.key)}/:memberSlug` ),
    name: 'TeamDetail',
    components: {
      header: AppHeader,
      default: TeamDetail,
      footer: AppFooter
    },
  },
  {
    path: "/:slug",
    name: 'StaticInfos',
    components: {
      header: AppHeader,
      default: StaticInfos,
      footer: AppFooter
    },
  },
  {
    path: '*',
    name: '404',
    components: {
      header: AppHeader,
      default: Page404,
      footer: AppFooter
    }
  }, 
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
